module.exports = __webpack_public_path__ + "img/12.08928ed3.jpg";